module.exports = __webpack_public_path__ + "media/wo.6281f537.mp3";